<div class="row white py-4 px-3 mx-0 rounded shadow-sm">
    <div class="col-12 p-0 m-0">

        <div class="row m-0">
            <div class="col-12">
                <p>
                    {{ 'WARRANTY_INFO.LABEL1' | translate }} <b> {{ 'WARRANTY_INFO.LABEL2' | translate }} </b>
                </p>            
            </div>
        </div>
        
        <div class="row m-1">
            <div class="col-12 col-lg-6 d-flex flex-column p-0 p-lg-1">
                <div class="d-flex flex-row">
                    <div>
                        <img src="../../../assets/img/reemplazo-icon.png" alt="">
                    </div>
                    <div class="mt-2 ms-2">
                        <h5 class="fw-bold"> {{ 'WARRANTY_INFO.LABEL3' | translate }} </h5>
                        <ul>
                            <li class="mb-2"> {{ 'WARRANTY_INFO.LABEL4' | translate }} </li>
                            <li class="mb-2"> {{ 'WARRANTY_INFO.LABEL5' | translate }} </li>
                            <li class="mb-2"> {{ 'WARRANTY_INFO.LABEL6' | translate }} </li>
                        </ul>
                        <img src="../../../assets/img/reemplazo_img.png" *ngIf="!isMobile" alt="">
                    </div>
                </div>
                <div *ngIf="isMobile">
                    <img src="../../../assets/img/reemplazo_img.png" class="w-100 my-3" alt="">
                </div>
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column p-0 p-lg-1">
                <div class="d-flex flex-row">
                    <div>
                        <img src="../../../assets/img/reparaciones-icon.png" alt="">
                    </div>
                    <div class="mt-2 ms-2">
                        <h5 class="fw-bold"> {{ 'WARRANTY_INFO.LABEL7' | translate }} </h5>
                        <ul>
                            <li class="mb-2"> {{ 'WARRANTY_INFO.LABEL8' | translate }} </li>
                            <li class="mb-2"> {{ 'WARRANTY_INFO.LABEL9' | translate }} </li>
                            <li class="mb-2"> {{ 'WARRANTY_INFO.LABEL10' | translate }} </li>
                        </ul>
                        <img src="../../../assets/img/reparacion_img.png" *ngIf="!isMobile" alt="">
                    </div>
                </div>
                <div *ngIf="isMobile">
                    <img src="../../../assets/img/reparacion_img.png" class="w-100 my-3" alt="">
                </div>
            </div>
        </div>
        <div class="row m-0 justify-content-center mt-3">
            <div class="col-12 col-lg-8 text-center">
                <p class="fw-bold">
                    {{ 'WARRANTY_INFO.LABEL11' | translate }} 
                    <br>
                    {{ 'WARRANTY_INFO.LABEL12' | translate }} 
                </p>
            </div>
        </div>
    </div>
</div>
